var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.column === _vm.name && _vm.order === 'asc')?_c('span',{staticClass:"table-sort-icon"},[_c('IconChevronUpSmall')],1):_vm._e(),(_vm.column === _vm.name && _vm.order === 'desc')?_c('span',{staticClass:"table-sort-icon"},[_c('IconChevronDownSmall')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }